"use client";
import { SetStateAction, useState } from "react";

import {
  Box,
  Typography
} from "@mui/material";

import FooterComponent from "../../components/footer";
import Header from "../../components/header/header";
import DocumentMeta from "react-document-meta";
import "./cookie.css";

export default function Cookie(): JSX.Element {
  const [message, setMessage] = useState("");

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setMessage(event.target.value);

    console.log("value is:", event.target.value);
  };
  const [open, setOpenState] = useState(false);

  const meta = {
    title: "Cookies | 123Skincare",
    canonical: "https://www.123skincare.pro/cookie",
  };

  return (
    <DocumentMeta {...meta}>
      <Header showLogo={true} />
      <Box className="main cookies-page">

      <Box className="container">
        <Box className="wrapper">
          <div><h1>123Skincare Cookie Policy</h1></div>

          <div className="paragraph">
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            123skincare respects your privacy and is committed to protect any
            personal information that you may submit through our website. The
            following information is designed to help you understand what
            information 123skincare gathers from the website and how this
            information is handled.{" "}
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            To make this site work properly, we sometimes place small cookies on
            users’ devices. Most big websites do this too. By accessing,
            browsing and/or using our website, you acknowledge, without
            limitation or qualification, that you have read, understood and
            agreed to be subject to the terms and conditions of this policy, and
            therefore consent to our use of cookies in accordance with these
            terms.
          </Typography>

          <Typography sx={{ marginTop: "20px" }} variant={"h4"}>
            What are cookies?
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            A cookie is a small text file that a website saves on your computer
            or mobile device when you visit a site. It enables the website to
            remember your actions and preferences (such as login, language, font
            size and other display preferences) over a period of time, so you
            don’t have to keep re-entering them whenever you come back to the
            site or browse from one page to another.
          </Typography>

          <Typography sx={{ marginTop: "20px" }} variant={"h4"}>
            What are the different types of cookies?
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            A cookie can be classified by its lifespan and the domain to which
            it belongs. By lifespan, a cookie is either a:
            <ul>
              <li>
                session cookie which is erased when you close the browser or
              </li>
              <li>
                persistent cookie which remains on your computer/device for a
                pre-defined period of time.
              </li>
            </ul>
          </Typography>

          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            As for the domain to which it belongs, there are either:
            <ul>
              <li>first-party cookies which are set by 123skincare or</li>
              <li>
                third-party cookies stored by a different domain to the visited
                page’s domain.
              </li>
            </ul>
          </Typography>

          <Typography sx={{ marginTop: "20px" }} variant={"h4"}>
            How do we use cookies?
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            Our website uses cookies to ensure the best experience for you. We
            use both session and persistent cookies on our website. Enabling our
            first and third party cookies is not strictly necessary for the
            website to work but it will provide you with a better browsing
            experience. You can delete or block these cookies, but if you do
            that some features of this site may not work as intended.
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            The cookie-related information is not used to identify you
            personally and the pattern data is fully under our control. All our
            cookies are not used for any purpose other than those described
            below.
          </Typography>

          <Typography sx={{ marginTop: "20px" }} variant={"h4"}>
            Which cookies do we use?
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            We use our own cookies to remember your actions and custom
            preferences. We also use our own first-party cookies to help you
            complete tasks without having to re-enter information when browsing
            from one page to another or when you visit the site later.
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            We use third party cookies to improve your experience with digital
            analytics and real-time personalization. We also use third party
            cookies for online behavioral advertising and to show adverts
            relevant to something that you searched for in the past.
          </Typography>

          <Typography sx={{ marginTop: "20px" }} variant={"h4"}>
            How to control cookies?
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            You can control and/or delete cookies as you wish – for details, see{" "}
            <a target="_blank" href="https://aboutcookies.org">
              aboutcookies.org
            </a>
            . You can delete all cookies that are already on your computer and
            you can set most browsers to prevent them from being placed.
            However, deleting or blocking all cookies will have a negative
            impact on the stability of many websites. If you choose to block our
            cookies, you will have to manually adjust some preferences every
            time you visit our site and some services and functionalities may
            not work.
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            This policy may be updated from time to time, e.g. due to
            modifications of relevant legislation or changes to 123skincare’s
            corporate structure. We encourage you to periodically review this
            page for the latest information on our cookie policy.
          </Typography>
          </div>
          <FooterComponent />
        </Box>
      </Box>
    </Box>
    </DocumentMeta>
  );
}
